module.exports = __webpack_public_path__ + "static/media/magellan-logo-white.72d9aeaf.svg";